import React from 'react';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { StyledTableHead } from '../ProjectedCashFlowReport.styles';
import { PeriodDTO } from '../ProjectedCashFlowReport.meta';

interface Props {
  columns: PeriodDTO[] | string[];
  title: string;
}

export const TableHead = ({ columns, title }: Props) => {
  const data = columns.slice(0, 5);
  return (
    <tr>
      <th aria-label={title === 'Period' ? 'Empty Header' : `${title}'s Age`}>
        <Text textAlign="left">{title === 'Period' ? '' : `${title}'s Age`}</Text>
      </th>
      {data.map(curr => {
        if (title === 'Period') {
          return (
            <th key={curr.Text}>
              <Text variant="tabular" textAlign="right">
                {curr.Text}
              </Text>
            </th>
          );
        }
        return (
          <StyledTableHead key={curr}>
            <Text variant="tabular" textAlign="right">
              {curr}
            </Text>
          </StyledTableHead>
        );
      })}
    </tr>
  );
};
